import styles from "../styles.module.css";
import { Form, Input, Popconfirm } from "antd";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close-icon-current.svg";
import { useRef } from "react";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";
import { useDispatch } from "react-redux";
import { setLoadingSurvey } from "../../../redux/slices/loadingSurvey";
import { StarIcon } from "lucide-react";

const SurveyOptionItem = ({ option, index, surveyId, showRating }) => {
  const { getSurveyInfo, deleteSurveyOption, updateSurveyOption } = useSurvey();
  const timeRef = useRef(null);
  const dispatch = useDispatch();

  const handleUpdateSurveyOption = async (data) => {
    if (timeRef.current) {
      clearTimeout(timeRef.current);
    }

    timeRef.current = setTimeout(async () => {
      dispatch(setLoadingSurvey(true));
      const res = await updateSurveyOption({
        ...data,
        go_to: null,
        detail: false,
      });

      if (res) {
        await getSurveyInfo(Number(surveyId));
      }
      dispatch(setLoadingSurvey(false));
    }, 1000);
  };
  return (
    <div className={styles["survey-question-option-container"]}>
      <Form.Item
        name={`option_${index + 1}`}
        label={`${!showRating ? "Opción" : "Calificación"} ${index + 1}`}
        className={styles["survey-question-option-item"]}
        initialValue={option.option}
      >
        <Input
          prefix={showRating ? <StarIcon style={{color: "gold"}} /> : undefined}
          onChange={(e) => {
            handleUpdateSurveyOption({
              id_question_option: option.id,
              option: e.target.value || " ",
            });
          }}
        />
      </Form.Item>
      <div style={{ marginTop: 30, cursor: "pointer", height: 0 }}>
        <Popconfirm
          title="¿Eliminar opción?"
          okText="Eliminar"
          okButtonProps={{ danger: true }}
          onConfirm={async () => {
            await deleteSurveyOption(option.id);
            await getSurveyInfo(Number(surveyId));
          }}
        >
          <CloseIcon />
        </Popconfirm>
      </div>
    </div>
  );
};

export default SurveyOptionItem;
